export interface Enterprise {
  id: number
  name: string
  avatar: string
}

export const ENTERPRISES: Enterprise[] = [
  {
    id: 1,
    name: 'Snack Prompt',
    avatar: 'http://files.snackprompt.com.s3-website.us-east-2.amazonaws.com/enterprise-logo-1.png',
  },
  {
    id: 2,
    name: 'Test Enterprise',
    avatar: 'http://files.snackprompt.com.s3-website.us-east-2.amazonaws.com/enterprise-logo-2.png',
  },
]
